import axios from "axios";
import { getEnv } from "./helpers/env.ts";
import type { MenuData, PageData, ProductData } from "./rest.interface.ts";

export async function fetchMenuByUrl(url: string): Promise<MenuData> {
	return axios.get(getEnv('PUBLIC_API_HOST') + '/api/menu/' + url)
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status + ':', error.config.url, url);
			}
		});
}

export async function fetchMenuById(id: number): Promise<MenuData> {
	return axios.get(getEnv('PUBLIC_API_HOST') + '/api/menu/' + id)
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status + ':', error.config.url, id);
			}
		});
}

export async function fetchPageByUrl(url: string): Promise<PageData> {
	return axios.get(getEnv('PUBLIC_API_HOST') + '/api/page/url', {params: {url: url}})
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status + ':', error.config.url, url)
			}
		});
}

export async function fetchPageById(id: number): Promise<PageData> {
	return axios.get(getEnv('PUBLIC_API_HOST') + '/api/page/' + id)
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status + ':', error.config.url, id)
			}
		});
}

export async function fetchArtworkByUrl(url: string): Promise<ProductData> {
	return axios.get(getEnv('PUBLIC_API_HOST') + '/api/product/url', {params: {url: url}})
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status + ':', error.config.url, url)
			}
		});
}

export async function fetchArtworkById(id: number): Promise<ProductData> {
	return axios.get(getEnv('PUBLIC_API_HOST') + '/api/product/' + id)
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status + ':', error.config.url, id)
			}
		});
}
